/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { isMobile } from '../../components/breakpoints';

import { IEcommMobileIsoViewProps } from './ecomm-mobile-iso';

/**
 *
 * IEcommMobileIsoViewProps component
 * @extends {React.PureComponent<IEcommMobileIsoViewProps>}
 */
export class EcommMobileIsoView extends React.PureComponent<IEcommMobileIsoViewProps> {
    public state: any = { width: 0, hasMounted: false };

    public componentDidMount(): void {
        if (!this.state.hasMounted) {
            window.addEventListener('resize', this._updateDimensions);

            this.setState({ width: window.innerWidth, hasMounted: true });
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.hasMounted) {
            return null;
        }

        if (!isMobile(this.state.width)) {
            return null;
        }

        const { config } = this.props;

        return (
            <div className='ecomm-mobile-iso row'>
                <div className='title col-9'>
                    <h4>{config.title}</h4>
                </div>
                <div className='logo col-3'>
                    <img src={config.isoLogo.src} />
                </div>
            </div>
        );
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this._updateDimensions);
    }

    private _updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };
}

export default EcommMobileIsoView;
